module.exports = __webpack_public_path__ + "static/media/LakeCarolina-menu-homes.3f384068.jpg";